module.exports = __webpack_public_path__ + "img/w2.5309f17c.jpg";